import { CollectionList, CollectionListProps } from '../CollectionList';
import React from 'react';
import { PageInfiniteScrollLoader } from '../PageInfiniteScrollLoader';
import { FiltersMap } from '@wix/bex-core';

export interface InfiniteScrollCollectionListProps<
  T,
  F extends FiltersMap = FiltersMap,
> extends CollectionListProps<T, F> {}

export function InfiniteScrollCollectionList<
  T,
  F extends FiltersMap = FiltersMap,
>(props: InfiniteScrollCollectionListProps<T, F>) {
  const { state } = props;
  return (
    <CollectionList {...props}>
      <PageInfiniteScrollLoader
        dataHook="infinite-scroll-loader"
        state={state.collection}
      />
    </CollectionList>
  );
}
